module.exports = "img/matrix-org-bw-logo.e8617d8.svg";